export default {
  BASE_V1_API: "https://vgsa.viewgres.com/api/v1",
  BASE_V1_TEST_API: "https://vgsa.viewgres.com/api/v1",
  BASE_VIEWGRES_V4_API: "https://i.viewgres.com:4321/vgc/api/v4" // 唯格云api
};
